import React from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ToastContainerWithTheme() {
  const color1 = useSelector((state) => state.teamState?.config?.color1);
  const progressColor = color1 || "#6366f1";
  const AUTO_CLOSE_TIME_MS = 5000;

  return (
    <>
      <style>{`.Toastify__progress-bar { background: ${progressColor} !important; }`}</style>
      <ToastContainer position="top-right" autoClose={AUTO_CLOSE_TIME_MS} style={{ top: 'env(safe-area-inset-top, 0px)' }} />
    </>
  );
}
